import { DefaultTheme } from 'styled-components';

const Theme: DefaultTheme = {
  primaryFont: '"Poppins", sans-serif',
};

export default Theme;
